import { render } from "./HeaderElement.vue?vue&type=template&id=1dc03c27&scoped=true"
import script from "./HeaderElement.vue?vue&type=script&lang=js"
export * from "./HeaderElement.vue?vue&type=script&lang=js"

import "./HeaderElement.vue?vue&type=style&index=0&id=1dc03c27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc03c27"]])

export default __exports__